import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function AddPCA() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    requisitante: '',
    objeto: '',
    justificativa: '',
    expectativa_consumo_anual: '',
    valor_preliminar: '',
    data_pretendida: '',
    prioridade: '',
    indicacao_vinculacao_dependencia: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post('/api/addpca', form)
      .then((res) => {
        if (res.data.Status === 'Success') {
          alert('PCA criado com sucesso!');
          navigate('/listapca');
        } else {
          alert('Erro ao criar PCA');
        }
      })
      .catch((err) => {
        console.error(err);
        alert('Erro no servidor');
      });
  };

  return (
    <div className="px-4 py-3">
      <h3 className="mb-4">Adicionar Novo PCA</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Requisitante</label>
          <input
            type="text"
            name="requisitante"
            className="form-control"
            required
            value={form.requisitante}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Objeto</label>
          <input
            type="text"
            name="objeto"
            className="form-control"
            required
            value={form.objeto}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Justificativa</label>
          <textarea
            name="justificativa"
            className="form-control"
            required
            value={form.justificativa}
            onChange={handleChange}
          ></textarea>
        </div>

        <div className="mb-3">
          <label>Expectativa de Consumo Anual</label>
          <input
            type="number"
            name="expectativa_consumo_anual"
            className="form-control"
            required
            value={form.expectativa_consumo_anual}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Valor Preliminar da Contratação</label>
          <input
            type="number"
            step="0.01"
            name="valor_preliminar"
            className="form-control"
            required
            value={form.valor_preliminar}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Data Pretendida para Contratação</label>
          <input
            type="date"
            name="data_pretendida"
            className="form-control"
            required
            value={form.data_pretendida}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Prioridade da Compra ou Contratação</label>
          <input
            type="text"
            name="prioridade"
            className="form-control"
            required
            value={form.prioridade}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Indicação de Vinculação</label>
          <input
            type="text"
            name="indicacao_vinculacao_dependencia"
            className="form-control"
            value={form.indicacao_vinculacao_dependencia}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary">
          Salvar PCA
        </button>
      </form>
    </div>
  );
}

export default AddPCA;
